module.exports = __webpack_public_path__ + "static/media/registerBanner.7def29d6.svg";